const faqs = [
  {
    q: '刃牙漫画在线观看需要注册吗？',
    a: '不需要。刃牙漫画免费在线平台对所有读者完全开放，无需注册或登录即可立即开始刃牙漫画在线阅读。打开浏览器，选择想看的章节，下拉式即可畅快阅读全部内容。',
  },
  {
    q: '刃牙漫画下拉式全集是什么意思？',
    a: '刃牙漫画下拉式全集是指采用连续滚动排版方式呈现的完整漫画内容。与传统翻页模式不同，您只需向下滑动页面，即可无缝阅读刃牙漫画的所有漫画页，无需点击翻页按钮，体验更流畅。',
  },
  {
    q: '刃牙漫画全集包含哪些篇章？',
    a: '我们收录了刃牙漫画全集，包括第一部刃牙（371话）、刃牙II（276话）、范马刃牙（312话）、刃牙道（连载中）的全部内容，以及烈海王异世界、花山薰外传等番外作品，刃牙漫画在线观看全集一网打尽。',
  },
  {
    q: '刃牙漫画免费在线阅读画质如何？',
    a: '我们提供高清刃牙漫画免费在线阅读服务，所有漫画页面均经过专业数字化处理，完美还原板垣恵介老师的原画细节。支持图片缩放，在手机和桌面端均能获得清晰细腻的刃牙漫画在线看体验。',
  },
  {
    q: '刃牙漫画在线看支持哪些设备？',
    a: '刃牙漫画在线看支持所有主流设备。无论是Windows/Mac电脑、iPhone/iPad、还是各类安卓手机和平板，只要使用现代浏览器，即可流畅体验刃牙漫画下拉式阅读。无需下载任何软件，即开即读。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          阅读帮助
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10 md:mb-14">
          刃牙漫画在线观看常见问题解答
        </p>

        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <details key={idx} className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden" open={idx === 0}>
              <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-heading text-foreground-900 pr-4">{faq.q}</h3>
                <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200 group-open:bg-primary-100 transition-colors">
                  <i className="ri-arrow-down-s-line text-foreground-500 group-open:text-primary-500 transition-transform group-open:rotate-180"></i>
                </div>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}